import { rest } from 'msw'

export default [
  /**
   * 都道府県
   */
   rest.get('/swc-api/master/pf-areas', (req, res, ctx) => {
    // If authenticated, return a mocked pf-area
    return res(
      ctx.status(200),
      ctx.json([
        {
          "id": "01",
          "name": "北海道"
        },
        {
          "id": "02",
          "name": "東北"
        },
        {
          "id": "03",
          "name": "関東"
        },
        {
          "id": "04",
          "name": "北陸"
        },
        {
          "id": "05",
          "name": "中部"
        },
        {
          "id": "06",
          "name": "近畿"
        },
        {
          "id": "07",
          "name": "中国"
        },
        {
          "id": "08",
          "name": "四国"
        },
        {
          "id": "09",
          "name": "九州"
        },
      ]),
    )
  }),
]
